export enum EntryMethod {
  Empty = 'Empty',
  Scanned = 'Scanned',
  Keyed = 'Keyed',
  Repeat = 'Repeat',
  Tapped = 'Tapped',
  Weighed = 'Weighed',
  Promotion = 'Promotion',
  Automatic = 'Automatic',
  Implicit = 'Implicit',
  MSR = 'MSR',
  WavedSmartCard = 'WavedSmartCard',
  WavedMSR = 'WavedMSR',
  Manual = 'Manual',
  // Added for donation through pinpad
  PinPad = 'PinPad',
  Barcode = 'Barcode',
}
